
import Loading from 'vux/src/components/loading/index.vue'

import {mapState} from 'vuex'

export default {
name: 'App',
data() {
return {
loadText: "加载中",
isWeChat: false,
showToast: false,
toastText: ''
}
},
components: {
Loading
},
computed: {
...mapState({
isLoading: state => state.isLoading
})
},
created() {
this.isWeiXinOpen()
},
methods: {
isWeiXinOpen() {
let ua = window.navigator.userAgent.toLowerCase();
let url = window.location.href
if (ua.match(/MicroMessenger/i) == 'micromessenger' || url.indexOf('cglx2') !== -1 || url.indexOf('home') !== -1|| url.indexOf('byPhoneSearch') !== -1|| url.indexOf('peopleControl2') !== -1|| url.indexOf('applyDetail2') !== -1|| url.indexOf('choosePerson2') !== -1|| url.indexOf('secondaryRegister2') !== -1 || url.indexOf('seatInquiry') !== -1) {
this.isWeChat = true
} else {
this.isWeChat = false
}
}
}

}



// WEBPACK FOOTER //
// ./src/App.vue